import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog-stacked";
import { Button } from "@/components/ui/button";
import { META } from "@/lib/typography";

interface PrivacyWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel?: string;
  confirmDisabled?: boolean;
  onConfirm: () => void;
}

export function PrivacyWarningDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Share anyway",
  confirmDisabled = false,
  onConfirm,
}: PrivacyWarningDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <p className={META}>{description}</p>
        <div className="flex gap-3 mt-4">
          <Button
            variant="secondary"
            size="modal"
            onClick={() => onOpenChange(false)}
            className="flex-1 cursor-pointer"
          >
            Cancel
          </Button>
          <Button
            variant="gradient"
            size="modal"
            onClick={onConfirm}
            disabled={confirmDisabled}
            className="flex-1 cursor-pointer"
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
